export default "__VITE_ASSET__COGDD3db__"